import { Parallax } from 'react-parallax';
import HeroImg from '../assets/finance_hero.jpg'
import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";
import { useLang } from "../context/LangContext";
import "../styles/main_hero.css";


const HeroSection = () => {
  const [content, setContent] = useState({});
  const { lang } = useLang();

  useEffect(() => {
    fetchPageContent("finance", lang).then(data => setContent(data));
  }, [lang]);
  
  return (
    <Parallax 
    blur={1.5} 
    bgImage={HeroImg} 
    bgImageAlt="hero img" 
    strength={600}
    className="hero-img"
    >
    
    <span className="hero-content" >
    {content.finance_title && (  
   <p className="hero-text">{content.finance_title}</p>
    )}  
    {content.finance_location && ( 
   <p className="hero-subtext">{content.finance_location}</p>
    )}  

    </span>
    </Parallax>
  );
}
export default HeroSection;